'use client';

import dynamic from 'next/dynamic';
import { useState } from 'react';
import useUser from '@alltrails/context/hooks/useUser';
import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';
import { wrapUrlSafe } from '@alltrails/core/utils/wrapUrlSafe';
import ToutSection from '../ToutSection';
import ignMapsDesktopSrc from './ignMapsImage-D.webp';
import ignMapsMobileSrc from './ignMapsImage-M.webp';

const SignUpModal = dynamic(() => import('@alltrails/user-auth/components/SignUpModal'), { ssr: false });

// component is fr-FR only; no translations needed
// Design: https://www.figma.com/design/lvC7R32ufa3s4yBI6UCgfV/IGN-Map-Layers-GTM?node-id=746-18
const IgnMapsTout = () => {
  const user = useUser();
  const languageRegionCode = useLanguageRegionCode();
  const [isSignupModalOpen, setIsSignupModalOpen] = useState(false);
  const localizedExploreUrl = wrapUrlSafe('/explore', languageRegionCode);

  const buttonProps = !user
    ? {
        onClick: () => {
          setIsSignupModalOpen(true);
        }
      }
    : { linkInfo: { href: '/explore', isNativeLink: true as const } }; // no need to use wrapUrlSafe since this is a relative path

  return (
    <>
      <ToutSection
        altText="Cartes IGN"
        buttonProps={buttonProps}
        buttonText="Découvrir"
        contentLayout="wide"
        desktopImage={ignMapsDesktopSrc}
        mobileImage={ignMapsMobileSrc}
        subtitle="Planifiez avec les cartes de cette grande agence cartographique, désormais disponibles dans l'application et sur le web."
        title="Nouveau ! Cartes IGN"
      />
      {isSignupModalOpen && (
        <SignUpModal
          closeModal={() => setIsSignupModalOpen(false)}
          isOpen={isSignupModalOpen}
          onSuccess={() => {
            setIsSignupModalOpen(false);
            window.location.assign(localizedExploreUrl);
          }}
          trigger="IGN Maps"
          upsellTrigger="IGN Maps"
        />
      )}
    </>
  );
};

export default IgnMapsTout;
